//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

/**
 * TODO: PD-242286 cleanup after post details pages removed
 * From now on, we will use the UniversalPostType defined in app/apis/universal-posts/universalPostsApiModel.ts to distinguish between types of scheduled/draft posts
 * @deprecated
 */
export enum PostDetailsPostType {
  FacebookPageFeed = 'facebook-page-feed',
  InstagramFeedAutomatic = 'instagram-feed-automatic',
  InstagramFeedManual = 'instagram-feed-manual',
  InstagramReelsAutomatic = 'instagram-reels-automatic',
  InstagramReelsManual = 'instagram-reels-manual',
  InstagramStoryGroup = 'instagram-story-group',
  PinterestOrganicPin = 'pinterest-oragnic-pin',
  TikTokVideoAutomatic = 'tiktok-video-automatic',
  TwitterPostingGroup = 'twitter-posting-group',
}

export const AllUniversalPostTypes = Object.values(PostDetailsPostType);
